module.exports = __webpack_public_path__ + "img/grand-pool-2.7982958f.jpg";